import _get from 'lodash/get';
import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { fetchArticle, receiveArticleError } from './action-article';
import { updateUserSelection } from './action-update-user-selection';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const CANCEL_TOPIC_MESSAGE = 'cancel topic request';

export function requestTopicData(id) {
  return {
    type: types.REQUEST_TOPIC_DATA,
    payload: { id },
  };
}

function receiveTopicData(responseData) {
  const contactChannel = _get(responseData, 'formInfo.form_elements.contact_channel', {});
  return {
    type: types.RECEIVE_TOPIC_DATA_RESPONSE,
    payload: contactChannel,
  };
}

function receiveFormFields(responseData) {
  const formFields = _get(responseData, 'formInfo.form_elements.webform_detail', []);
  const kanaCode = _get(responseData, 'formInfo.kana_code', '');
  const topicRefId = _get(responseData, 'formInfo.topicRefId', '');
  return {
    type: types.RECEIVE_FORM_FIELDS,
    payload: {
      kanaCode,
      formFields,
      topicRefId,
    },
  };
}

export function receiveTopicDataError() {
  return {
    type: types.RECEIVE_TOPIC_DATA_ERROR,
    payload: undefined,
  };
}

function receiveFAQID(faqId) {
  return {
    type: types.RECEIVE_FAQID,
    payload: faqId,
  };
}

function receiveFAQIDError() {
  return {
    type: types.NO_FAQID,
    payload: undefined,
  };
}

function fetchFAQIDData(responseData) {
  return (dispatch) => {
    const faqId = _get(responseData, 'formInfo.form_elements.faqid[0].default_text', undefined);
    if (faqId) {
      dispatch(fetchArticle(faqId));
      dispatch(receiveFAQID(faqId));
    } else {
      dispatch(receiveFAQIDError());
      dispatch(receiveArticleError());
    }
  };
}

export function fetchTopicData(topicId) {
  return (dispatch) => {
    dispatch(requestTopicData(topicId));
    return axios.get(`/smarthelp/topic-data/?topic_id=${topicId}`, {
      cancelToken: source.token,
    })
      .then((response) => {
        dispatch(receiveTopicData(response.data));
        dispatch(receiveFormFields(response.data));
        dispatch(fetchFAQIDData(response.data));
        dispatch(updateUserSelection('contactUsPage'));
      })
      .catch((error) => {
        if (error && error.message !== CANCEL_TOPIC_MESSAGE) {
          dispatch(receiveTopicDataError());
        }
        dispatch(receiveArticleError());
      });
  };
}

export function cancelTopicDataRequest() {
  source.cancel(CANCEL_TOPIC_MESSAGE);
}
